import React from 'react'
import { ourblog } from '../../utility/ourblog'
import { Fade } from 'react-awesome-reveal'

function SoftwareBlog() {
    const handleSubmit = (e) => {
        e.preventDefault()
    }
    return (
        <section className="section-blog padding-tb-100 bg-market">
            <div className="container">
                <div className="row">
                    <Fade triggerOnce duration={2000} direction='up' className="col-12" >
                        <div className="banner justify-content-center">
                            <h2>Recent Post From Our Blog</h2>
                        </div>
                    </Fade>
                    <div className="col-lg-6 col-md-12">
                        {
                            ourblog.map((data, index) => (
                                <div key={index} className="digital-blog">
                                    <Fade triggerOnce duration={2000} direction='up'>

                                        <h4><code>{data.title} </code> - {data.date} - 05 Comment</h4>
                                        <p>{data.discription}</p>
                                        <a onClick={handleSubmit} href="/">
                                            <h5>Read more <i className="fa-solid fa-arrow-right-long"></i></h5>
                                        </a>
                                    </Fade>

                                </div>
                            ))
                        }
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <Fade triggerOnce duration={2000} direction='up'>
                            <img src="assets/img/home/blog.png" alt="Blog" className="blog-image" />
                            <div className="digital-blog">
                                <h4><code>Sales </code> - 18 Mar 2022 - 05 Comment</h4>
                                <p>Machine Learning vs. Deep Learning: Understanding the Differences. Unraveling the Power of AI in Text.</p>
                                <a onClick={handleSubmit} href="/">
                                    <h5>Read more<i className="fa-solid fa-arrow-right-long"></i></h5>
                                </a>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SoftwareBlog
